import { ProductListView } from '~/types/internal-api';
import useQuery, { QueryOptions, QueryResult } from '../useQuery';

/**
 * Custom hook responsible to fetch products
 */
export function useProducts({
    isAccessible,
    pageSize,
    options,
}: {
    isAccessible?: boolean;
    pageSize?: number;
    options?: QueryOptions;
}): QueryResult<ProductListView[]> {
    const productsQuery = useQuery<{ data: ProductListView[] }>(
        `/products?${isAccessible ? 'filter=isAccessible$eq:true' : ''}${pageSize ? `&pageSize=${pageSize}` : '&returnAll=true'}`,
        [],
        { ...options, useCache: options?.useCache ?? true }
    );
    return { ...productsQuery, data: productsQuery?.data?.data ?? [] };
}
